export default `return mat2( cos( r ), sin( r ), -sin( r ), cos( r ) );
}

float de ( vec3 p ) {
  float e = 1.0, g;
  p = asin( sin( p ) );
  for( int i = 0; i++ < 7; ){
    p = abs( p ) - 0.1;
    p = p.x > p.y ? p.zxy : p.zyx;
    p *= 2.0;
    e *= 2.0;
    p.xz *= rotate2D( 2.8 );
    p.yx = abs( p.yx ) - 4.0;
  }
  p /= e;
  return e = abs( p.z ) * 0.6 - 0.02;
}`